import { Component, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { ContextInfoCustomFormType } from 'src/app/model/enum/observations/custom-forms/custom-form-context-info-type.enum';

@Component({
    selector: 'paetep-cf-builder-context-info',
    templateUrl: './paetep-cf-builder-context-info.component.html',
    styleUrls: ['./paetep-cf-builder-context-info.component.scss'],
    viewProviders: [{
        provide: ControlContainer,
        useFactory: (container: ControlContainer) => container,
        deps: [[new SkipSelf(), ControlContainer]]
    }]
})
export class PaetepCfBuilderContextInfoComponent {

    ContextInfoCustomFormType = ContextInfoCustomFormType;

    constructor(private container: ControlContainer) { }

    get questionId(): string {
        return this.container.control!.parent!.get('_id')!.value;
    }

    get contextTypeId(): string {
        return `contextType-${this.questionId}`;
    }
}
